import { render, staticRenderFns } from "./ExtraFieldTextOptions.vue?vue&type=template&id=9cc45f02"
import script from "./ExtraFieldTextOptions.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldTextOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cc45f02')) {
      api.createRecord('9cc45f02', component.options)
    } else {
      api.reload('9cc45f02', component.options)
    }
    module.hot.accept("./ExtraFieldTextOptions.vue?vue&type=template&id=9cc45f02", function () {
      api.rerender('9cc45f02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/ExtraFieldTextOptions.vue"
export default component.exports